<form [formGroup]="fiscaleEenheidFg">
  <snelstart-ui-details-content class="row">
    <ng-container formArrayName="samenstelling">
      <ng-container *ngFor="let item of samenstelling.controls; let i = index; trackBy: trackByFn" [formGroupName]="i">
        <snelstart-ui-details-content>
          <snelstart-ui-text-form-control formControlName="naamOnderneming"
                                          [label]="i === 0 ? 'Naam onderneming' : ''"
                                          id="naamOnderneming"
                                          [required]=true
                                          class="me-1 custom-input-250"
                                          (change)="this.saveForm()"
          >
          </snelstart-ui-text-form-control>
          <snelstart-ui-date-form-control formControlName="datumOpname"
                                          id="datumOpname"
                                          [label]="i === 0 ? 'Ingangsdatum' : ''"
                                          placeholder="dd-mm-jjjj"
                                          class="me-1 custom-input-150"
                                          (change)="this.saveForm()"
          >
          </snelstart-ui-date-form-control>
          <snelstart-ui-date-form-control formControlName="datumEinde"
                                          id="datumEinde"
                                          [label]="i === 0 ? 'Einddatum' : ''"
                                          placeholder="dd-mm-jjjj"
                                          class="me-1 custom-input-150"
                                          (change)="this.saveForm()"
          >
          </snelstart-ui-date-form-control>
          <snelstart-ui-text-form-control formControlName="omzetbelastingNummer"
                                          id="omzetbelastingNummer"
                                          [label]="i === 0 ? 'Fiscaal nummer' : ''"
                                          class="me-1 custom-input-150"
                                          (change)="this.saveForm()"
          >
          </snelstart-ui-text-form-control>
<!--          <snelstart-ui-select-form-control formControlName="sstAdminId"-->
<!--                                            id="sstAdminId"-->
<!--                                            [label]="i === 0 ? 'Snelstart administratie' : ''"-->
<!--                                            class="me-1 custom-input-200"-->
<!--                                            [options]="options"-->
<!--                                            (change)="this.saveForm()"-->
<!--          >-->
<!--          </snelstart-ui-select-form-control>-->
<!--          <snelstart-ui-button type="primary"-->
<!--                               class="me-1"-->
<!--                               [class]="i === 0 ? 'me-1 pt-3' : 'me-1'"-->
<!--                               (click)="this.getAdministration(i)">Importeren-->
<!--          </snelstart-ui-button>-->
          <snelstart-ui-button class="delete"
                                      id="buttonDelete"
                                      type="secondary"
                                      size="medium"
                                      iconType="light"
                                      (click)="verwijderRij(i)"
                                      [class]="i === 0 ? 'pt-3' : ''"
          >
          </snelstart-ui-button>
        </snelstart-ui-details-content>
      </ng-container>
    </ng-container>
  </snelstart-ui-details-content>
</form>

<div *ngIf="samenstelling.length === 0">
  <snelstart-ui-button id="cancelA" class="snelstart-ui-button pb-3" type="link" icon="plus"
                       (click)="addRij()">Onderneming invullen
  </snelstart-ui-button>
</div>
<div *ngIf="samenstelling.length !== 0">
  <snelstart-ui-button id="cancelB" class="snelstart-ui-button pb-3" type="link" icon="plus"
                       (click)="addRij()">Onderneming toevoegen
  </snelstart-ui-button>
</div>
